/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevRobotIcon24Solid = forwardRef('DevRobotIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 3.461A1.874 1.874 0 0 0 12 0a1.875 1.875 0 0 0-1 3.461V5H8a5 5 0 0 0-5 5v1.75H1.25a1.25 1.25 0 1 0 0 2.5H3V18a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5v-3.75h1.75a1.25 1.25 0 1 0 0-2.5H21V10a5 5 0 0 0-5-5h-3V3.461ZM17 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-8.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" })));
});
